// Client-side cookie utilities for React
import {
  getClientCookie,
  setClientCookie,
  deleteClientCookie,
  getAuthTokenCookie,
  setAuthTokenCookie,
  deleteAuthTokenCookie,
  getRefreshTokenCookie,
  setRefreshTokenCookie,
  deleteRefreshTokenCookie,
  getSessionKeyCookie,
  setSessionKeyCookie,
  deleteSessionKeyCookie
} from "./clientCookie";

import { COOKIE_NAME, REFRESH_TOKEN_NAME, SESSION_KEY, SIDEBAR_COOKIE_NAME } from "./cookieOptions";

export type CookieType = "authToken" | "refreshToken" | "sessionKey" | "sidebar";

const COOKIE_NAME_MAP: Record<CookieType, string> = {
  authToken: COOKIE_NAME,
  refreshToken: REFRESH_TOKEN_NAME,
  sessionKey: SESSION_KEY,
  sidebar: SIDEBAR_COOKIE_NAME,
};

export function getCookie(type: CookieType): string {
  return getClientCookie(COOKIE_NAME_MAP[type]) || "";
}

export default function setCookie(type: CookieType, value: string) {
  setClientCookie(COOKIE_NAME_MAP[type], value, 7);
}

export function deleteCookie(type: CookieType) {
  deleteClientCookie(COOKIE_NAME_MAP[type]);
}

// Re-export specific cookie functions for convenience
export {
  getAuthTokenCookie,
  setAuthTokenCookie,
  deleteAuthTokenCookie,
  getRefreshTokenCookie,
  setRefreshTokenCookie,
  deleteRefreshTokenCookie,
  getSessionKeyCookie,
  setSessionKeyCookie,
  deleteSessionKeyCookie
};
